import React from 'react'
import { Text, StandardFieldLabel } from '@adc/ui-adc'
import * as graph from '@adc/sdk'

export const radioOptions = [
  {
    label: (
      <StandardFieldLabel
        label='Buyer Who Intends to Live in the Property'
        elmId='homebuyer'
        subLabel='You are the buyer or their agent purchasing a property to use as a primary residence.'
      />
    ),
    value: graph.enums.FirstLookBuyerSelectionType.Homebuyer,
  },
  {
    label: (
      <StandardFieldLabel
        label='Entity Approved for First Look Properties'
        elmId='entity'
        subLabel={
          <Text size='tiny' color='grayMedium'>
            You are an employee or agent representing a government entity or
            non-profit.
          </Text>
        }
      />
    ),
    value: graph.enums.FirstLookBuyerSelectionType.EntityApproved,
  },
  {
    label: (
      <StandardFieldLabel
        label='Investor'
        elmId='investor'
        subLabel='You are buying an investment property or a second home.'
      />
    ),
    value: graph.enums.FirstLookBuyerSelectionType.Investor,
  },
]

export const californiaSpecialTreatmentRadioOptions = [
  {
    label: (
      <StandardFieldLabel
        label='Buyer Who Intends to Live in the Property'
        elmId='homebuyer'
        subLabel='You are purchasing a property to use as a primary residence.'
      />
    ),
    value: graph.enums.FirstLookBuyerSelectionType.Homebuyer,
  },
  {
    label: (
      <StandardFieldLabel
        label='Entity Approved for First Look Properties'
        elmId='entity'
        subLabel={
          <Text size='tiny' color='grayMedium'>
            You are purchasing as a qualified governmental entity or non-profit.
          </Text>
        }
      />
    ),
    value: graph.enums.FirstLookBuyerSelectionType.EntityApproved,
  },
  {
    label: (
      <StandardFieldLabel
        label='Investor'
        elmId='investor'
        subLabel='You are buying an investment property or a second home.'
      />
    ),
    value: graph.enums.FirstLookBuyerSelectionType.Investor,
  },
]
